import React, { useState } from 'react'

const linkMain = "https://apps.apple.com/mx/app/gimwork/id6450014304"

const CampaignScreen = () => {

    const [text, setText] = useState("")
    const values = [
        { name: "Tik tok", link: "pt=0&ct=tiktok_ad&mt=8" },
        { name: "Instagram", link: `pt=0&ct=instagram_feed&mt=8` },
        { name: "Facebook", link: "pt=0&ct=facebook_campaign&mt=8" },
        { name: "Google ads", link: "pt=0&ct=google_ads_search&mt=8" },
        { name: "Linkedlin", link: "pt=0&ct=linkedin_post&mt=8" },
    ]
    return (
        <div 
            className=""
            style={{
                width: "100vw",
                overflowY: "scroll"
            }}
        >
            <textarea
                style={{
                    height: "40vh",
                    width: "95%",
                    marginTop: "2rem",
                    border: "solid 1px #ff000088",
                    fontSize: "2rem",
                    padding: "1rem"
                }}
                 onChange={(e) => setText(e.target.value)}
                 value={text}
            >

            </textarea>
            <button
                onClick={() => {
                    window.location.href = text
                }}
                style={{
                    width: "90%",
                    height: "3.5rem",
                    backgroundColor: "#ff000088",
                    color: "white",
                    borderRadius: 3,
                    marginTop: "2rem",
                    fontSize: "2rem"
                }}
            >
                Go
            </button>
            {
                values.map((v) => {
                    return (
                        <button
                            onClick={() => {
                                window.location.href = `${linkMain}?${v.link}`
                            }}
                            style={{
                                width: "90%",
                                height: "3.5rem",
                                backgroundColor: "#00ff0088",
                                color: "white",
                                borderRadius: 3,
                                marginTop: "1rem",
                                fontSize: "2rem"
                            }}
                        >
                            {v.name}
                        </button>
                    )
                })
            }
        </div>
    )
}

export default CampaignScreen